import { useReactToPrint } from "react-to-print";
import DeliveryTable from "../components/DeliveryTable";
import { useRef } from "react";
import "../components/Table.css";
import "../components/Print.css";
import "./DeliveriesPage.css";

const DeliveriesPage = () => {
  const printableRef = useRef<HTMLTableElement | null>(null);

  const handlePrint = useReactToPrint({
    contentRef: printableRef,
    documentTitle: "List of Delivery",
  });
  return (
    <div className="page-container">
      <h1>This Week's Deliveries</h1>
      <div className="btn-aligned-right-box">
        <button className="btn btn-aligned-right" onClick={handlePrint}>
          <span className="only-big-screen">🖨️</span> Print or Save
        </button>
      </div>
      <div className="page-content deliveries-page-content">
        <DeliveryTable printableRef={printableRef} />
      </div>
    </div>
  );
};

export default DeliveriesPage;
